export function hasReadPermission(config, permission) {
  return [1, true, 'read', 'edit'].includes(config[permission]);
}

export function hasEditPermission(config, permission) {
  return ['edit'].includes(config[permission]);
}

export function hasPermission(config, permission) {
  return [1, true, 'read', 'edit'].includes(config[permission]);
}

export function getHighestPermissionModule(permission, config1, config2) {
  const bool =
    hasPermission(config1, permission) || hasPermission(config2, permission);
  return bool ? 1 : 0;
}

export function getHighestPermissionFeature(permission, config1, config2) {
  if (
    hasEditPermission(config1, permission) ||
    hasEditPermission(config2, permission)
  ) {
    return 'edit';
  }
  if (
    hasReadPermission(config1, permission) ||
    hasReadPermission(config2, permission)
  ) {
    return 'read';
  }
  return 'off';
}
